import { Form, TabPanel, Tabs } from 'tea-component';
import React, { useMemo } from 'react';
import BubbleCommon, {
  keywordDrillUrlTopicAnalysisTips,
} from '@op/components/BubbleCommon';
import KeywordTips from '@op/components/FilterCommon/widgets/KeyWordsSelect/KeywordTips';
import useLanguage from '@op/hooks/useLanguage';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';
import { keywordsReplaceText } from '@op/components/FilterCommon/widgets/KeyWordsSelect/utils';
import { DefaultImg } from '@op/constants/defaultImg';
import './index.scss';
import {
  getKeywordPalaceholder,
  getKeywordTopicPalaceholder,
} from '@op/components/FilterCommon/utils/keyword';
import AutoTextAreaBox from '@op/components/FilterCommon/components/AutoTextAreaBox';
import TagList from '@op/components/FilterCommon/components/TagList';

interface IKeywordTopicOptionsProps {
  gameInfo: any;
  keywordInput: string;
  keywordGrammarText: string;
  keywordGrammarTrue: boolean;
  setKeywordInput: (value: string) => void;
  tab: 'keyword' | 'topic';
  // setTab: (value: 'keyword' | 'topic') => void;
  topicInput: string;
  setTopicInput: (value: string) => void;
  loading: boolean;
  isTopicAnalysis?: boolean;
}

export default function KeywordTopicOptions({
  gameInfo,
  setKeywordInput,
  keywordGrammarText,
  keywordGrammarTrue,
  keywordInput,
  tab = 'keyword',
  topicInput,
  setTopicInput,
  // setTab,
  loading,
  isTopicAnalysis,
}: IKeywordTopicOptionsProps) {
  const { formatMessage, isEn } = useLanguage();
  const { keyword_analysis_shortcut, keyword_topic_shortcut } =
    useRequestFontWebConfig({
      keys: [
        { key: 'keyword_analysis_shortcut', defaultValue: [] },
        { key: 'keyword_topic_shortcut', defaultValue: [] },
      ],
      gameInfo,
    });

  const { list, setValue } = useMemo(() => {
    if (tab === 'keyword') {
      return {
        list: keyword_analysis_shortcut,
        setValue: setKeywordInput,
      };
    }

    return { list: keyword_topic_shortcut, setValue: setTopicInput };
  }, [
    keyword_analysis_shortcut,
    keyword_topic_shortcut,
    tab,
    setKeywordInput,
    setTopicInput,
  ]);

  // Tab 选项配置
  const tabs = useMemo(() => {
    const baseConfig = { disabled: loading };

    return [
      {
        ...baseConfig,
        id: isTopicAnalysis ? 'topic' : 'keyword',
        label: (
          <div className="dbo-keyword-topic-tab-flex">
            {isTopicAnalysis && <img src={DefaultImg.AI} alt="" />}
            <span className="dbo-keyword-topic-tab-text">
              {formatMessage(
                isTopicAnalysis ? 'Natural Language Search' : 'Keyword Search',
              )}
            </span>
          </div>
        ),
      },
    ];
  }, [isTopicAnalysis, loading, formatMessage]);

  return (
    <Form.Item
      className="dbo-keyword-topic-options-wrapper"
      label={
        <BubbleCommon
          style={{ maxWidth: 500 }}
          {...(tab === 'topic'
            ? { tipsMap: keywordDrillUrlTopicAnalysisTips }
            : { content: <KeywordTips isBubble></KeywordTips>, tipsMap: null })}
          placement="top"
        >
          {formatMessage({ id: 'Query' })}
        </BubbleCommon>
      }
    >
      {/* 文本域获得焦点 增加 dbo--focus */}
      <div
        className={`dbo-keyword-topic-tab-box-outer ${
          tab === 'topic' ? 'dbo--focus' : ''
        }`}
      >
        <Tabs
          tabs={tabs}
          activeId={tab}
          className="dbo-keyword-topic-tab-box"
          // onActive={(tabItem) => setTab(tabItem.id as 'keyword')}
        >
          <div className="dbo-analysis-url-row">
            <TagList list={list} setValue={setValue} isEn={isEn}></TagList>
          </div>

          <TabPanel id="keyword">
            <AutoTextAreaBox
              value={keywordInput}
              replaceText={keywordsReplaceText}
              grammarTrue={keywordGrammarTrue}
              grammarText={formatMessage(keywordGrammarText)}
              minHeight={152}
              setValue={setKeywordInput}
              placeholder={getKeywordPalaceholder(formatMessage)}
            ></AutoTextAreaBox>
          </TabPanel>
          <TabPanel id="topic">
            <AutoTextAreaBox
              value={topicInput}
              hasTips={false}
              grammarText={formatMessage(keywordGrammarText)}
              minHeight={152}
              setValue={setTopicInput}
              placeholder={getKeywordTopicPalaceholder(formatMessage)}
            ></AutoTextAreaBox>
          </TabPanel>
        </Tabs>
      </div>
    </Form.Item>
  );
}
